import { render } from "./loading.md?vue&type=template&id=6f80af79"
import script from "./loading.md?vue&type=script&lang=js"
export * from "./loading.md?vue&type=script&lang=js"
script.render = render

export default script